import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from '../../context/AuthContext';

const TermsApprovedRoute = () => {
  // User will be able to access pages inside of this Router only after changing password
  const { isFirstLogin } = useAuth();

  if (Number(isFirstLogin)) {
    return <Navigate to="/change-password" />
  }

  return <Outlet />
};

export default TermsApprovedRoute;
